/** The Mappings tabs, in their order, as their path segment names them. */
export enum MappingsTab {
	FIELDS = 'fields',
	VALUES = 'values',
	ASSET_TYPES = 'asset-types',
	LOOKUPS = 'lookups',
	UNMAPPED_FIELDS = 'unmapped-fields',
	HISTORY = 'history',
}

export const MAPPINGS_TAB_LABELS: Record<MappingsTab, string> = {
	[MappingsTab.FIELDS]: 'Fields',
	[MappingsTab.VALUES]: 'Values',
	[MappingsTab.ASSET_TYPES]: 'Asset types',
	[MappingsTab.LOOKUPS]: 'Lookups',
	[MappingsTab.UNMAPPED_FIELDS]: 'Unmapped fields',
	[MappingsTab.HISTORY]: 'History',
}

export const MAPPINGS_PATHS = {
	root: '/admin/workfront/mappings',
	tab: (tab: MappingsTab) => `/admin/workfront/mappings/${tab}`,
	/** A new Fields row reading the parameter, from Unmapped fields. */
	mapField: (parameterId: string) =>
		`/admin/workfront/mappings/${MappingsTab.FIELDS}?parameter=${encodeURIComponent(parameterId)}&edit=1&source=unmapped`,
}
